import { useState, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import Navbar from "./Component/Navbar/Navbar";

import { BrowserRouter as Router } from "react-router-dom";
import Homepage from "./Page/HomePage/Homepage";
import { theme } from "./Styled/Theme/Theme";
import GlobalStyles from "./Styled/Globalstyle/Global";
import Projects from "./Page/Projects/Projects";
import About from "./Page/About/About";
import Skill from "./Page/Skills/Skill";
import Footer from "./Page/footer/Footer";
import ParallaxComponent from "./Page/paralax/Paralax";
import Service from "./Page/Service/Service";
import { HelmetProvider } from "react-helmet-async";
import Seo from "./SEO/Seo";
import Loading from "./Page/Loading/Loading";
// import Testimonial from "./Page/Tastomonial/Tastomonial";
// import TestimonialSection from "./Page/Tastomonial/Tastomonial";

const VISITED_KEY = "portfolio_visited";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Check if user has visited before
    const hasVisited = localStorage.getItem(VISITED_KEY);
    
    if (!hasVisited) {
      // First visit - show loading screen
      setIsLoading(true);
      setShowContent(false);
    } else {
      // Returning visitor - skip loading
      setIsLoading(false);
      setShowContent(true);
    }
  }, []);

  const handleLoadingComplete = () => {
    // Mark as visited in localStorage
    localStorage.setItem(VISITED_KEY, "true");
    setIsLoading(false);
    
    // Small delay before showing content for smooth transition
    setTimeout(() => {
      setShowContent(true);
    }, 100);
  };

  return (
    <HelmetProvider>
      <Router>
        <ThemeProvider theme={theme}>
          <>
            <GlobalStyles />
            {isLoading && <Loading onComplete={handleLoadingComplete} />}
            {showContent && (
              <>
                <Seo />
                <Navbar />
                <Homepage />
                <Projects />
                <About />
                <ParallaxComponent />
                <Skill />
                <Service />
                {/* <TestimonialSection/> */}
                <Footer />
              </>
            )}
          </>
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
